import { io } from "socket.io-client";

import { HEADER_SESSION_ID } from "@virtual-brain-lib/utils-common";

import env from "../environments";

const URL = env.apiUrl;

export function initSocket({
	chatbotId,
	accessToken,
	sessionId,
}: {
	chatbotId: string;
	accessToken: string;
	sessionId?: string | undefined;
}) {
	return io(URL, {
		query: { chatbotId },
		extraHeaders: {
			...(accessToken ? { authorization: `Bearer ${accessToken}` } : {}),
			...(sessionId ? { [HEADER_SESSION_ID]: sessionId } : {}),
		},
	});
}
